module.exports = __webpack_public_path__ + "0.1.2/img/mean-details.646ea595.jpeg";